import * as React from "react";
import { Graphic, TextDescription, Wrapper } from "./descriptionStyled";

export class DescriptionComponent extends React.Component<{}> {
  public render() {
    return (
      <Wrapper>
        <TextDescription>
          Tell your co-workers how much you value them any day of the year. Give
          positive feedback about latest success or just say thank you.
          <br />
          <br />
          Remember,
        </TextDescription>
        <Graphic />
      </Wrapper>
    );
  }
}
